import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import IonIcon from '@reacticons/ionicons'
import cn from 'classnames'
import React from 'react'
import Slider from 'react-slick'
import { useCarouselSolutionsBySubTopicSlugQuery } from 'src/graphql/generated/hooks'

import { SolutionCarouselCard } from '../SolutionCarouselCard/SolutionCarouselCard'

export interface ProductsSolutionsCarouselProps {
  topicId?: string
  subTopicId?: string
  type?: string
}

export const ProductsSolutionsCarousel: React.FC<ProductsSolutionsCarouselProps> = (props) => {
  const { data } = useCarouselSolutionsBySubTopicSlugQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      query: {
        offset: 0,
        limit: 10,
        sort: 'Default',
        topic: props.topicId,
        subTopic: props.subTopicId,
        type: props.type || 'Product',
        includeCompany: false,
      },
    },
  })
  const solutions = data?.searchSolutions?.solutions || []
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: Math.min(solutions.length, 6),
    slidesToScroll: 1,
    arrows: true,
    nextArrow: (
      <div className="cursor-pointer">
        <IonIcon name="chevron-forward-outline" className="!h-[30px] !w-[30px] text-[black] ml-auto"></IonIcon>
      </div>
    ),
    prevArrow: (
      <div className="cursor-pointer">
        <IonIcon name="chevron-back-outline" className="!h-[30px] !w-[30px] text-[black] ml-auto"></IonIcon>
      </div>
    ),
  }

  return (
    <div className={cn('w-full px-5 sm:px-0 flex flex-row justify-center bg-white')}>
      <div className="max-w-screen-xl mx-32 w-full">
        <div className="mt-[40px] h-[150px] mb-[20px] px-[40px]">
          <Slider {...settings} adaptiveHeight={false}>
            {solutions.map((solution, idx) => (
              <SolutionCarouselCard key={idx} solution={solution} type={props.type} />
            ))}
          </Slider>
        </div>
      </div>
    </div>
  )
}
